// The JD panel itself stays JD-only on purpose: it reads `/johndeere/operations` and its actions
// PULL from JD, neither of which means anything without a link. So this says what is true — the
// data is here, here is where to see it — and leaves linking as an offer rather than a demand.
import { Layers } from "lucide-react";

export function UploadedMachineDataNote({ onLink }: { onLink?: () => void }) {
  return (
    <div className="flex items-start gap-2 rounded border border-line bg-canvas/40 p-2 text-[11px] leading-snug text-fg">
      <Layers size={13} className="mt-0.5 shrink-0 text-accent" />
      <span className="flex-1">
        This field&rsquo;s machine data came from an upload, not a John Deere
        link — its yield layers appear in the map&rsquo;s layer list once the
        covariate build finishes.
        {onLink &&
          " Linking a JD Ops field is optional, and lets you pull more operations."}
      </span>
      {onLink && (
        <button
          className="shrink-0 rounded border border-line px-2 py-1 text-[11px] text-fg hover:bg-hover"
          onClick={onLink}
        >
          Link a JD Ops field…
        </button>
      )}
    </div>
  );
}
